(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["knwn-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('knwn-home')) {
    customElements.define('knwn-home', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.knwn-film-toggle');
        if (!this.video || !this.toggle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const update = () => {
          const active = !this.video.paused;
          this.toggle.textContent = active ? this.toggle.dataset.pause : this.toggle.dataset.play;
          this.toggle.setAttribute('aria-pressed', String(active));
        };
        this.toggle.hidden = false;
        this.video.muted = true;
        this.video.addEventListener('playing', () => { this.video.classList.add('is-playing'); update(); }, options);
        this.video.addEventListener('pause', update, options);
        this.toggle.addEventListener('click', () => {
          if (this.video.paused) this.video.play().catch(() => update());
          else this.video.pause();
        }, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.video.pause(); }, options);
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData) this.video.play().catch(() => update());
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
